import { TEXT_SIZES } from "../constants/textSizes";

export type Direction = "up" | "down";

export function findNearestStep(current: number, direction: Direction): number | null {
    if (direction === "up") {
        for (const step of TEXT_SIZES) {
            if (step > current) {
                return step;
            }
        }
    }

    if (direction === "down") {
        for (let i = TEXT_SIZES.length - 1; i >= 0; i--) {
            if (TEXT_SIZES[i] < current) {
                return TEXT_SIZES[i];
            }
        }
    }

    return null;
}
